if (!customElements.get('diamond-shapes-gallery')) {
  customElements.define(
    'diamond-shapes-gallery',
    class DiamondShapesGallery extends HTMLElement {
      connectedCallback() {
        this.defaultPreview = this.querySelector('[data-featured-default]');
        this.hoverPreviews = this.querySelectorAll('[data-shape-preview]');
        this.shapeItems = this.querySelectorAll('[data-shape-preview-id]');
        this.openLinkOnClick = this.dataset.openLinkOnClick === 'true';
        this.mobileLayout = this.dataset.mobileLayout || 'compact';

        const desktopInteraction = this.dataset.interaction || 'hover_and_click';
        const mobileInteraction = this.dataset.mobileInteraction || 'tap';
        this.interaction = this.getEffectiveInteraction(desktopInteraction, mobileInteraction);

        if (!this.defaultPreview && this.hoverPreviews.length === 0) return;

        const useHover =
          this.interaction === 'hover' || this.interaction === 'hover_and_click';
        const useClick =
          this.interaction === 'click' ||
          this.interaction === 'hover_and_click' ||
          this.interaction === 'tap' ||
          this.interaction === 'tap_and_hover';

        this.shapeItems.forEach((item) => {
          const trigger = item.querySelector('.diamond-shapes__item');
          if (!trigger) return;

          if (useHover) {
            item.addEventListener('mouseenter', () => this.activatePreview(item));
            trigger.addEventListener('focusin', () => this.activatePreview(item));
          }

          if (useClick) {
            trigger.addEventListener('click', (event) =>
              this.handleShapeClick(event, item, trigger)
            );
          }
        });

        if (useHover && !this.isMobileViewport()) {
          this.addEventListener('mouseleave', (event) => {
            if (!this.contains(event.relatedTarget)) {
              this.showDefaultPreview();
              this.clearActiveShape();
            }
          });
        }

        this.showDefaultPreview();
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.mobileQuery.addEventListener('change', () => {
          this.interaction = this.getEffectiveInteraction(
            this.dataset.interaction || 'hover_and_click',
            this.dataset.mobileInteraction || 'tap'
          );
        });
      }

      isMobileViewport() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      isTouchDevice() {
        return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
      }

      getEffectiveInteraction(desktopInteraction, mobileInteraction) {
        const onMobile = this.isMobileViewport() || this.isTouchDevice();

        if (!onMobile || mobileInteraction === 'same') {
          return desktopInteraction;
        }

        if (mobileInteraction === 'tap') {
          return 'click';
        }

        if (mobileInteraction === 'tap_and_hover') {
          return 'hover_and_click';
        }

        return mobileInteraction;
      }

      handleShapeClick(event, item, trigger) {
        const hasLink =
          trigger.tagName === 'A' &&
          trigger.getAttribute('href') &&
          trigger.getAttribute('href') !== '#';
        const previewOnlyClick = trigger.getAttribute('data-preview-only-click') === 'true';

        // Navigate when open-link-on-click is enabled (no preview-only flag).
        if (hasLink && this.openLinkOnClick && !previewOnlyClick) return;

        event.preventDefault();
        this.activatePreview(item);

        if (
          this.isMobileViewport() &&
          item.dataset.shapePreviewId &&
          this.mobileLayout !== 'compact'
        ) {
          item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }

      activatePreview(item) {
        const previewId = item.dataset.shapePreviewId;
        if (!previewId) return;

        const preview = this.querySelector(`#${CSS.escape(previewId)}`);
        if (!preview) return;

        this.shapeItems.forEach((shape) => shape.classList.remove('is-active'));
        item.classList.add('is-active');

        this.setActivePreview(preview);

        if (this.isMobileViewport() && this.mobileLayout !== 'compact') {
          const featured = this.querySelector('.diamond-shapes__featured-col');
          featured?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      showDefaultPreview() {
        if (this.defaultPreview) {
          this.setActivePreview(this.defaultPreview);
        } else if (this.hoverPreviews.length > 0) {
          this.setActivePreview(this.hoverPreviews[0]);
        }
      }

      setActivePreview(activeImage) {
        const allPreviews = this.querySelectorAll(
          '[data-featured-default], [data-shape-preview]'
        );
        allPreviews.forEach((img) => {
          img.classList.toggle('is-active', img === activeImage);
        });
      }

      clearActiveShape() {
        this.shapeItems.forEach((shape) => shape.classList.remove('is-active'));
      }
    }
  );
}
